
import React, { useState } from "react";
import CustomerModal from "./CustomerModal";
import api from "../api/api";

export default function CustomerList({ customers, onItemClick, onConfirmOrder }) {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

 const handleConfirmOrder = async (customer) => {
  if (!customer.verified) return;

  const username = sessionStorage.getItem("username") || "UnknownUser";

  try {
    const response = await api.get("ConfirmOrders", {
      OId: customer.OrdNo,
      User: username,
    });

    const data = response?.ConfirmOrdersjs;

    if (data?.Table && data.Table.length > 0 && data.Table[0].AlertMsg) {
      alert(data.Table[0].AlertMsg);
      return;
    }

    if (data && Object.keys(data).length === 0) {
      alert(`Order ${customer.OrdNo} confirmed successfully!`);
      
      // ✅ Refresh the page after confirmation
      window.location.reload();
      return;
    }

    alert(`Failed to confirm order ${customer.OrdNo}.`);
  } catch (error) {
    console.error("❌ Confirm order API error:", error);
    alert("Error confirming order. Please check the console for details.");
  }
};

  const handleView = async (customer) => {
    try {
      const response = await api.GetCustomerList(customer.Vid, customer.UserType);

      const custData = response?.GetCustomerListjs?.Table?.[0] || null;

      if (custData) {
        setSelectedCustomer({
          id: customer.Vid,
          name: custData.Vname || "",
          email: custData.Mail || "",
          mobile: custData.VCode || "",
          address: `${custData.Address1 || ""}, ${custData.Address2 || ""}, ${custData.City || ""}`,
          pincode: custData.Pincode || "",
          area: custData.City || "",
          landmark: custData.Address2 || "",
          verified: customer.verified || false,
          UserType: customer.UserType || "",
        });
        setModalOpen(true);
      } else {
        console.warn("No customer data returned from API");
      }
    } catch (error) {
      console.error("Failed to fetch customer details:", error);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCustomer(null);
  };

  const handleVerify = (id, status) => {
    console.log("Verified status updated:", id, status);
    handleCloseModal();
  };

  return (
    <div className="overflow-x-auto bg-white shadow rounded-xl">
      <table className="min-w-[1500px] w-full text-sm text-left border-collapse">
        <thead className="text-white bg-orange-500">
          <tr>
            <th className="p-3 whitespace-nowrap">Slno</th>
            <th className="p-3 whitespace-nowrap">Name</th>
            <th className="p-3 whitespace-nowrap">Phone</th>
            <th className="p-3 whitespace-nowrap w-[800px]">Address</th>
            <th className="p-3 whitespace-nowrap">Circle</th>
            <th className="p-3 whitespace-nowrap">OrdNo</th>
            <th className="p-3 whitespace-nowrap">Item</th>
            <th className="p-3 text-center whitespace-nowrap">Count</th>
            <th className="p-3 whitespace-nowrap">ODate</th>
            <th className="p-3 whitespace-nowrap">DvlDate</th>
            <th className="p-3 whitespace-nowrap">Mode</th>
            <th className="p-3 text-right whitespace-nowrap">Amount</th>
            <th className="p-3 whitespace-nowrap">Status</th>
            <th className="p-3 text-center whitespace-nowrap">Action</th>
            <th className="p-3 text-center whitespace-nowrap">Confirm</th>
          </tr>
        </thead>

        <tbody>
          {customers.map((c, index) => (
            <tr key={c.id} className="transition-colors border-b hover:bg-gray-50">
              <td className="p-3 whitespace-nowrap">{c.id}</td>
              <td className="p-3 font-semibold whitespace-nowrap">{c.name}</td>
              <td className="p-3 whitespace-nowrap">{c.mobile}</td>
              <td className="p-3 text-gray-700 break-words max-w-[800px]">{c.address || "-"}</td>
              <td className="p-3 whitespace-nowrap">{c.circle}</td>
              <td className="p-3 whitespace-nowrap">{c.OrdNo}</td>
              <td
                className="p-3 text-blue-600 underline cursor-pointer bg-orange-50 hover:text-blue-800 whitespace-nowrap"
                onClick={() => onItemClick(c)}
              >
                View Item
              </td>
              <td className="p-3 text-center whitespace-nowrap">{c.ItemCnt}</td>
              <td className="p-3 whitespace-nowrap">{c.ODate}</td>
              <td className="p-3 whitespace-nowrap">{c.DvlDate}</td>
              <td className="p-3 whitespace-nowrap">{c.Paymode}</td>
              <td className="p-3 text-right whitespace-nowrap">{c.Amount}</td>
              <td className="p-3 whitespace-nowrap">
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    c.verified ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                  }`}
                >
                  {c.verified ? "Verified" : "Not Verified"}
                </span>
              </td>
              <td className="p-3 text-center whitespace-nowrap">
                <button
                  onClick={() => handleView(c)}
                  disabled={c.verified}
                  className={`bg-orange-500 text-white py-1 px-3 rounded-md text-xs hover:bg-orange-600 ${
                    c.verified ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  View / Verify
                </button>
              </td>
              <td className="p-3 text-center whitespace-nowrap">
                <button
                  disabled={!c.verified || c.confirmed}
                  onClick={() => handleConfirmOrder(c)}
                  className={`py-1 px-3 rounded-md text-xs font-semibold ${
                    c.verified
                      ? c.confirmed
                        ? "bg-gray-400 text-white cursor-not-allowed"
                        : "bg-green-600 text-white hover:bg-green-700"
                      : "bg-gray-300 text-gray-600 cursor-not-allowed"
                  }`}
                >
                  {c.confirmed ? "Confirmed" : "Confirm Order"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalOpen && selectedCustomer && (
        <CustomerModal
          customer={selectedCustomer}
          onClose={handleCloseModal}
          onVerify={handleVerify}
        />
      )}

      <div className="block py-2 text-xs text-center text-gray-500 sm:hidden">
        ↔ Scroll table to view all columns
      </div>
    </div>
  );
}


// import React, { useState } from "react";
// import CustomerModal from "./CustomerModal";
// import api from "../api/api";

// export default function CustomerList({ customers, onItemClick, onConfirmOrder }) {
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);

//   const handleConfirmOrder = async (customer) => {
//     if (!customer.verified) return;

//     try {
//       const response = await api.get("ConfirmOrders", {
//         OId: customer.OrdNo,
//         User: "admin", 
//       });

//       if (response?.ConfirmOrdersjs) {
//         alert(`Order ${customer.OrdNo} confirmed successfully!`);

//         customer.confirmed = true;
//       } else {
//         alert(`Failed to confirm order ${customer.OrdNo}`);
//       }
//       window.location.reload();
//     } catch (error) {
//       console.error("Confirm order API error:", error);
//       alert("Error confirming order. Check console for details.");
//     }
//   };

//   const handleView = async (customer) => {
//     try {

//       const response = await api.GetCustomerList(customer.Vid, customer.UserType);

//       const custData = response?.GetCustomerListjs?.Table?.[0] || null;

//       if (custData) {
//         setSelectedCustomer({
//           id: customer.Vid,
//           name: custData.Vname || "",
//           email: custData.Mail || "",
//           mobile: custData.VCode || "",
//           address: `${custData.Address1 || ""}, ${custData.Address2 || ""}, ${custData.City || ""}`,
//           pincode: custData.Pincode || "",
//           area: custData.City || "",
//           landmark: custData.Address2 || "",
//           verified: customer.verified || false,
//           UserType: customer.UserType || "",
//         });
//         setModalOpen(true);
//       } else {
//         console.warn("No customer data returned from API");
//       }
//     } catch (error) {
//       console.error("Failed to fetch customer details:", error);
//     }
//   };

//   const handleCloseModal = () => {
//     setModalOpen(false);
//     setSelectedCustomer(null);
//   };

//   const handleVerify = (id, status) => {
//     console.log("Verified status updated:", id, status);
//     handleCloseModal();
//   };

//   return (
//     <div className="overflow-x-auto bg-white shadow rounded-xl">
//       <table className="min-w-[1500px] w-full text-sm text-left border-collapse">
//         <thead className="text-white bg-orange-500">
//           <tr>
//             <th className="p-3 whitespace-nowrap">Slno</th>
//             <th className="p-3 whitespace-nowrap">Name</th>
//             <th className="p-3 whitespace-nowrap">Phone</th>
//             <th className="p-3 whitespace-nowrap w-[800px]">Address</th>
//             <th className="p-3 whitespace-nowrap">Circle</th>
//             <th className="p-3 whitespace-nowrap">OrdNo</th>
//             <th className="p-3 whitespace-nowrap">Item</th>
//             <th className="p-3 text-center whitespace-nowrap">Count</th>
//             <th className="p-3 whitespace-nowrap">ODate</th>
//             <th className="p-3 whitespace-nowrap">DvlDate</th>
//             <th className="p-3 whitespace-nowrap">Mode</th>
//             <th className="p-3 text-right whitespace-nowrap">Amount</th>
//             <th className="p-3 whitespace-nowrap">Status</th>
//             <th className="p-3 text-center whitespace-nowrap">Action</th>
//             <th className="p-3 text-center whitespace-nowrap">Confirm</th>
//           </tr>
//         </thead>

//         <tbody>
//           {customers.map((c, index) => (
//             <tr
//               key={c.id}
//               className="transition-colors border-b hover:bg-gray-50"
//             >
//               <td className="p-3 whitespace-nowrap">{c.id}</td>
//               <td className="p-3 font-semibold whitespace-nowrap">{c.name}</td>
//               <td className="p-3 whitespace-nowrap">{c.mobile}</td>
//               <td className="p-3 text-gray-700 break-words max-w-[800px]">{c.address || "-"}</td>
//               <td className="p-3 whitespace-nowrap">{c.circle}</td>
//               <td className="p-3 whitespace-nowrap">{c.OrdNo}</td>
//               <td
//                 className="p-3 text-blue-600 underline cursor-pointer bg-orange-50 hover:text-blue-800 whitespace-nowrap"
//                 onClick={() => onItemClick(c)}
//               >
//                 View Item
//               </td>
//               <td className="p-3 text-center whitespace-nowrap">{c.ItemCnt}</td>
//               <td className="p-3 whitespace-nowrap">{c.ODate}</td>
//               <td className="p-3 whitespace-nowrap">{c.DvlDate}</td>
//               <td className="p-3 whitespace-nowrap">{c.Paymode}</td>
//               <td className="p-3 text-right whitespace-nowrap">{c.Amount}</td>
//               <td className="p-3 whitespace-nowrap">
//                 <span
//                   className={`px-3 py-1 rounded-full text-xs font-semibold ${c.verified ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
//                     }`}
//                 >
//                   {c.verified ? "Verified" : "Not Verified"}
//                 </span>
//               </td>
//               <td className="p-3 text-center whitespace-nowrap">
//                 <button
//                   onClick={() => handleView(c)}
//                   disabled={c.verified} // ✅ disable if already verified
//                   className={`bg-orange-500 text-white py-1 px-3 rounded-md text-xs hover:bg-orange-600 ${c.verified ? "opacity-50 cursor-not-allowed" : ""
//                     }`}
//                 >
//                   View / Verify
//                 </button>
//               </td>
//               <td className="p-3 text-center whitespace-nowrap">
//                 <button
//                   disabled={!c.verified || c.confirmed}
//                   onClick={() => handleConfirmOrder(c)}
//                   className={`py-1 px-3 rounded-md text-xs font-semibold ${c.verified
//                       ? c.confirmed
//                         ? "bg-gray-400 text-white cursor-not-allowed"
//                         : "bg-green-600 text-white hover:bg-green-700"
//                       : "bg-gray-300 text-gray-600 cursor-not-allowed"
//                     }`}
//                 >
//                   {c.confirmed ? "Confirmed" : "Confirm Order"}
//                 </button>
//               </td>


//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {modalOpen && selectedCustomer && (
//         <CustomerModal
//           customer={selectedCustomer}
//           onClose={handleCloseModal}
//           onVerify={handleVerify}
//         />
//       )}

//       <div className="block py-2 text-xs text-center text-gray-500 sm:hidden">
//         ↔ Scroll table to view all columns
//       </div>
//     </div>
//   );
// }
